import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../core/services/auth.service';

/**
 * Signale une session ouverte par PIN SANS RESEAU : aucun jeton en memoire,
 * identite et droits issus du coffre chiffre. Elle disparait d'elle-meme quand la
 * session est rattachee a Cognito. Invisible hors de ce cas.
 */
@Component({
  selector: 'app-session-hors-ligne-pastille',
  standalone: true,
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (auth.sessionHorsLigne()) {
      <div class="si" role="status">
        <div class="sd sd-red"></div>
        <span>{{ 'LOGIN.OFFLINE_MODE' | translate }}</span>
      </div>
    }
  `,
})
export class SessionHorsLignePastilleComponent {
  protected readonly auth = inject(AuthService);
}
